import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "store"
import type { IUser } from "types/userTypes"

interface UsersState {
  users: Array<IUser>
  selectedUser: IUser | undefined
  currentUser: IUser | undefined
}

const initialState: UsersState = {
  users: [] as IUser[],
  selectedUser: undefined,
  currentUser: undefined,
}

export const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<Array<IUser>>) => {
      state.users = action.payload
    },
    setSelectedUser: (state, action: PayloadAction<IUser>) => {
      state.selectedUser = action.payload
    },
    setCurrentUser: (state, action: PayloadAction<IUser | undefined>) => {
      state.currentUser = action.payload
    },
    addUser: (state, action: PayloadAction<IUser>) => {
      state.users?.push(action.payload)
    },
    updateUser: (state, action: PayloadAction<IUser>) => {
      var index = state.users.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.users[index] = action.payload
      }
    },
    removeUser: (state, action: PayloadAction<IUser>) => {
      var index = state.users.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.users.splice(index, 1)
      }
    },
    resetUsers: (state, _action) => {
      state.users = []
      state.selectedUser = undefined
    },
  },
})

export const {
  setUsers,
  setSelectedUser,
  setCurrentUser,
  addUser,
  updateUser,
  removeUser,
  resetUsers,
} = userSlice.actions

export const selectCount = (state: RootState) => state.users

export default userSlice.reducer
